module.exports = __webpack_public_path__ + "img/423339708139719_image.jpg";